document.addEventListener('DOMContentLoaded', function() {

  // Basis swiper + mogelijk lightgallery 

  document.querySelectorAll('.block-image-carousel').forEach(carousel => {
    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    const swiperId = carousel.id;

    const swiper = new Swiper(carousel.querySelector('.swiper-container'), {
      grabCursor: true,
      spaceBetween: 15,
      slidesPerView: 'auto',
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          spaceBetween: 30,
        },
        1024: {
          spaceBetween: 30,
        },
        1400: {
          spaceBetween: 40,
        },
        1500: {
          spaceBetween: 40,
        },
      },
      on: {
        init: function () {
          if( lightGallery !== undefined ) {
            const $lgSwiper = document.getElementById(swiperId);
            const lg = lightGallery($lgSwiper, {
              selector: '[data-src]',
              licenseKey: '2A6E6328-72AD-4CB4-8D1C-EA56CC30E2E9',
              supportLegacyBrowser: false
            });
            $lgSwiper.addEventListener('lgBeforeClose', () => {
              swiper.slideTo(lg.index, 0)
            });
          }
        },
      }
    });

  });

});